import LockboxTable from './LockboxTable';

export default LockboxTable;
